import axios from 'axios';
import { getBackendURL } from '../../Utils/ServerURL';
const sControllerEndpoint = 'GeneralSettings';


export class AdminSaleChannelAPI {

  getAdminTableData() {
    return axios.get(getBackendURL() + sControllerEndpoint);
  }

  saveEditElement(dto) {
    return axios.put(getBackendURL() + sControllerEndpoint, dto);
  }

}

export default AdminSaleChannelAPI


// WEBPACK FOOTER //
// ./src/API/Admin/AdminGeneralDefinitionsAPI.js